import { Inject, Injectable } from '@angular/core';
import SlotModel from '../../models/slot.model';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { LoaderActions } from '../../utils/loaders/loader-actions.enum';
import { LoadersService } from '../../utils/loaders/loaders.service';
import { IServerResponseResponse } from '../../interfaces/server-response.interface';

export interface IGadget {
  sku: string;
  name: string;
  brand: string;
  price: IGadgetPrice;
  pricePerPiece: IGadgetPrice;
  quantity: number;
  presale: boolean;
  quantityAligned: boolean;
  quantityLimitReached: boolean;
  image: string;
  bundledDevice: boolean;
}

export interface IGadgetPrice {
  net: string;
  gross: string;
}

@Injectable()
export class CommonGadgetsService {
  constructor(
    @Inject('Endpoint') private endpoint: any,
    private notificationProvider: NotificationProviderService,
    private loaderService: LoadersService,
  ) {

  }

  public prepareGadgets(_slot: SlotModel): void {
    const gadgets: IGadget[] = [];

    _slot.gadgets.forEach((item: IGadget, key: number) => {
      for(let i = 0; i < item.quantity; i++) {
        gadgets.push(item);
      }
    });

    this.updateList(_slot, gadgets);
  }

  public removeGadget({bundleNo, deviceId, offerId}: {bundleNo: number, deviceId: string, offerId: string}): void {
    this.startLoader();

    this.endpoint('gadget.removeGadget', {
      bundleNo: bundleNo,
      offerId: offerId,
      sku: deviceId
    })
      .run()
      .then(this.sendPageValidationCartResponse.bind(this))
      .finally(() => {
        this.stopLoader()
      });
  }

  private updateList(_slot: SlotModel, _gadgets: IGadget[]) {
    _slot._computedFields.gadgetsList = _gadgets;
  }

  private sendPageValidationCartResponse(response: IServerResponseResponse): void {
    if (!response) {
      return;
    }

    this.notificationProvider.publish(
      NotificationProviderTypeEnum.PAGE_VALIDATION_CART,
      response
    );
  }

  private startLoader(): void {
    this.loaderService.start(
      LoaderActions.MODAL_LOADER,
      {
        message: 'Sprawdzamy dostępność urządzeń',
        preventClose: true
      },
      true
    );
  }

  private stopLoader(): void {
    this.loaderService.stop(
      LoaderActions.MODAL_LOADER
    );
  }

}
